import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import dayjs from "dayjs";
import { mapActions } from "vuex";
import localeMixin from "@/locales/mixin.js";
import util from "../../../libs/util";
import AliCaptcha from "./components/AliCaptcha.vue";
export default {
  mixins: [localeMixin],
  components: {
    AliCaptcha: AliCaptcha
  },
  data: function data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      timeInterval: null,
      time: dayjs().format("HH:mm:ss"),
      // 表单
      formLogin: {
        account: "",
        pwd: "",
        code: "v9am"
      },
      // 表单校验
      rules: {
        account: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        }],
        pwd: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }]
      },
      isProduction: util.isProduction(),
      siteVerify: !util.isProduction(),
      captchaConfig: {
        config: {
          captchaId: "1020638843b5c03cf8f77aaad03f7c64",
          language: "cn",
          product: "bind"
        },
        handler: this.captchaHandler
      },
      loading: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
    /* window.getCaptchaResponse = (response) => {
         this.$api
             .siteVerify({
                 api_key: "d8f7963b3b42ce5e107b9bb805679989",
                 response,
             })
             .then((res) => {
                 this.siteVerify = true;
             });
     };*/
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/account", ["login"])), {}, {
    captchaHandler: function captchaHandler(captchaObj) {
      var _this2 = this;
      window.captchaObj = captchaObj;
      captchaObj.appendTo("#captcha").onReady(function () {}).onNextReady(function () {}).onBoxShow(function () {}).onError(function (e) {}).onSuccess(function () {
        _this2.sendLogin();
      });
    },
    refreshTime: function refreshTime() {
      this.time = dayjs().format("HH:mm:ss");
    },
    /**
     * @description 提交表单
     */
    // 提交登录信息
    submit: function submit() {
      var _this3 = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          //需只限制生产环境使用图形验证时打开
          // if (this.isProduction) {
          if (window.captchaObj) {
            window.captchaObj.showCaptcha();
          } else {
            return false;
          }
          // }else{
          //     this.sendLogin()
          // }
        } else {
          // 登录表单校验失败
          _this3.$message.error("表单校验失败，请检查");
        }
      });
    },
    sendLogin: function sendLogin() {
      var _window$captchaObj,
        _this4 = this;
      this.loading = true;
      var other = (_window$captchaObj = window.captchaObj) === null || _window$captchaObj === void 0 ? void 0 : _window$captchaObj.getValidate();
      this.login({
        account: this.formLogin.account,
        pwd: this.formLogin.pwd,
        other: other
      }).then(function () {
        // 重定向对象不存在则返回顶层路径
        _this4.$router.replace(_this4.$route.query.redirect || "/");
      }).finally(function () {
        return _this4.loading = false;
      });
    }
  })
};